import { PGLoginTranslation } from 'root/widgets/pg-login/types';

const translation: PGLoginTranslation = {
  loginTitle: 'Selamat datang di Rumah.com',
  loginDescription: 'Masuk atau daftar untuk mendapatkan pengalaman terbaik dari Rumah.com.',
  loginWithGoogle: 'Lanjutkan dengan Google',
  loginWithFacebook: 'Lanjutkan dengan Facebook',
  loginWithApple: 'Lanjutkan dengan Apple',
  emailInputPlaceholder: 'Alamat Email',
  continueBtn: 'Lanjutkan',
  dividerTitle: 'Atau',
  agentLoginPrompt: {
    label: 'Apakah anda agen properti?',
    linkTitle: 'Log In ke AgentNet',
  },
  googleLoginErrorInPrivateMode:
    'Silakan ubah setelan browser Anda untuk mengizinkan kuki atau coba gunakan mode incognito atau privat untuk dapat melanjutkan login dengan akun media sosial.',
  signUpTitle: 'Daftar Untuk Membuat Akun Baru',
  signUpDescription:
    'Sepertinya Anda tidak memiliki akun dengan alamat email tersebut, daftar untuk mendapatkan semua manfaat ini:',
  signUpInstructions: [
    'Lacak pertanyaan properti Anda sebelumnya dengan mudah',
    'Dapatkan akses cepat ke pencarian tersimpan dan rumah pilihan Anda​',
    'Sinkronisasikan preferensi properti Anda di semua perangkat Anda',
  ],
  verifyBtn: 'Verifikasi Email Anda',
  signupCheckboxPrompts: {
    subscribe: 'Ya, kirimkan saya informasi perumahan baru, data properti terkini dan penawaran dari partner',
  },
  verifyEmailTitle: 'Verifikasi Email Anda',
  verifyEmailDescription: (email) => (
    <>
      Kami baru saja mengirimkan kode ke <strong>{email}</strong> Anda. Silakan periksa dan masukkan kode di sini untuk
      melanjutkan pendaftaran.
    </>
  ),
  resendAction: 'Kirim ulang kode',
  setPasswordTitle: 'Akun Anda Telah Berhasil Dibuat!​​',
  setPasswordDescription:
    'Kami menyarankan Anda membuat kata sandi untuk meningkatkan keamanan dan kemudahan akses ke akun Anda di masa mendatang.​​',
  passwordInputPlaceholder: 'Kata Sandi',
  savePasswordBtn: 'Simpan kata sandi saya',
  skipAction: 'Lewati Sekarang',
  otpLoginTitle: 'Login menggunakan OTP',
  otpLoginDescription: (email) => (
    <>
      Halo <strong>{email}</strong>, kami baru saja mengirimkan kode ke email Anda. Silakan periksa dan masukkan kode di
      sini untuk melanjutkan masuk.
    </>
  ),
  passwordLoginBtn: 'Masuk Dengan Kata Sandi',
  otpLoginBtn: 'Login menggunakan OTP',
  passwordLoginTitle: 'Masuk Dengan Kata Sandi',
  passwordLoginDescription: (email) => (
    <>
      Halo <strong>{email}</strong> silahkan masukan kata sandi Anda untuk login ke Rumah.com
    </>
  ),
  loginBtn: 'Log In',
  invalidPassword: 'Harap masukkan kata sandi yang valid',
  forgotPasswordAction: 'Lupa kata sandi',
  forgotPasswordTitle: 'Reset Kata Sandi',
  forgotPasswordDescription: 'Mohon masukkan alamat email Anda pada formulir di bawah ini.',
  resetPasswordBtn: 'Reset Kata Kunci Saya',
  checkSpamPrompt: (
    <>
      Tidak menerima email?
      <br />
      Silakan periksa folder spam atau kirim ulang kode
    </>
  ),
  footer: (
    <>
      Saya setuju untuk Rumah&#39;s <a href="/terms-of-service">Persyaratan Layanan</a> dan{' '}
      <a href="/privacy">Kebijakan Privasi</a> termasuk pengumpulan, penggunaan, dan pengungkapan informasi pribadi{' '}
      saya.
    </>
  ),
  errorMessages: {
    emailValidation: 'Harap masukkan alamat email yang valid',
    socialLogin: 'Maaf, ada kendala pada sistem login. Mohon coba lagi.',
    server: 'Maaf, ada kendala pada server. Mohon coba lagi.',
    charLengthValidation: 'Harus minimal 8 karakter',
    alphaNumericValidation: 'Harus mengandung karakter alfanumerik',
    capitalLetterValidation: 'Harus mengandung huruf kapital',
    specialCharValidation: 'Harus mengandung karakter khusus',
    invalidCode: 'Kode tidak valid. Coba lagi atau minta yang baru.',
    otpGenerationLimit: 'Maaf, saat ini Anda tidak bisa meminta kode baru. Silakan coba lagi dalam beberapa menit.',
    otpSubmissionLimit:
      'Maaf, saat ini kami tidak dapat memproses permintaan Anda. Silakan coba lagi dalam beberapa menit.',
  },
  verifyPhoneTitle: 'Verify Your Mobile Number', // Missing
  verifyEmailConsent: (email) => (
    <>
      We sent you a code at <strong>{email}</strong>. Please enter the code here to continue verifying.
    </>
  ), // Missing
  verifyPhoneConsent: (phone) => (
    <>
      We sent you a code via SMS to <strong>{phone}</strong>. Please enter the code here to continue verifying.
    </>
  ), // Missing
};

export default translation;
